import { Injectable } from '@angular/core';

import { SSE, SSEOptions } from 'sse.js';
import { EventSourceOptions, ServerSentEventsClient } from './sse.client';
import { toSSEOptions } from './sse-js.mapper';

@Injectable()
export class SSEJSClient extends ServerSentEventsClient {
  protected source!: SSE;
  protected closeCallback?: () => void;

  public connect(url: string, options: EventSourceOptions): void {
    const opts: SSEOptions = toSSEOptions(options);
    this.close();
    this.source = new SSE(url, opts);
  }

  public close(): void {
    if (this.source && this.source.readyState !== SSE.CLOSED) {
      console.debug('%c [sse-js client] - Closing SSE connection.', "color: orange");
      this.source.close();
    }
  }

  public onMessage(callback: (e: MessageEvent) => void): void {
    console.debug('%c [sse-js client] - onMessage callback registered for SSE.', "color: blue");
    this.source.addEventListener('message', (e: MessageEvent) => {
      callback(e);
    });

    this.source.stream();
  }

  public onClose(callback: () => void): void {
    console.debug('%c [sse-js client] - onClose callback registered for SSE.', "color: blue");
    this.closeCallback = callback;
    if (!this.source.listeners['readystatechange']) {
      console.debug('%c [sse-js client] - Adding readyStateListener for SSE.', "color: blue");
      this.source.addEventListener('readystatechange', this.readyStateListener);
    }
  }

  private readyStateListener = () => {
    if (this.source.readyState === SSE.CLOSED) {
      console.debug('%c [sse-js client] - SSE connection closed.', "color: orange");
      if (this.closeCallback) {
        this.closeCallback();
      }
    } else if (this.source.readyState === SSE.OPEN) {
      console.debug('%c [sse-js client] - SSE connection is open.', "color: green");
    } else if (this.source.readyState === SSE.CONNECTING) {
      console.debug('%c [sse-js client] - SSE connection is connecting.', "color: green");
    }
  }

  public onError(callback: (err: any) => void): void {
    console.debug('%c [sse-js client] - onError callback registered for SSE.', "color: blue");
    this.source.addEventListener('error', callback);
  }
}
